module.exports = __webpack_public_path__ + "static/img/1.d704140.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/1.png
// module id = C6bX
// module chunks = 0